import React from 'react'

const Stations = () => {
 return (
  <>
   <h2>i am theStations page</h2>
  </>
 )
}

export default Stations
